import DeskFloorPlan from './DeskFloorPlan';

export default DeskFloorPlan;
